module.exports = __webpack_public_path__ + "img/cloth_g3_pants-05.aff2df7b.svg";